<template>
    <v-row>
        <v-col cols="12" sm="12">
            <v-card>
                <v-card-title> {{ $t("Kyselyt") }} </v-card-title>
                <v-card-text>
                    <div v-if="isLoading">
                        <v-progress-circular :width="2" indeterminate></v-progress-circular>
                    </div>

                    <div v-else>
                        <survey-list :surveys="surveys"></survey-list>
                        <poll-list :polls="polls"></poll-list>
                    </div>

                    <div v-if="isEmpty" class="pl-4 pb-4">
                        <p>{{ $t("Ei kyselyjä") }}</p>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import useAuth from "@/useAuth";
import api from "@/api";
import { useTranslations } from "@/@core/libs/i18n";
import pollList from "@/components/polls/poll_list.vue";
import surveyList from "@/components/surveys/survey_list.vue";
import { onMounted, ref } from "@vue/composition-api";
import {
    mdiPoll,
} from "@mdi/js";

export default {
    components: {
        surveyList,
        pollList,
    },
    setup() {
        const isLoading = ref(true);
        const isEmpty = ref(false);

        const polls = ref([]);
        const surveys = ref([]);

        const fetch = async () => {
            await fetchPolls();
            await fetchSurveys();
            if (polls.value.length === 0 && surveys.value.length === 0) {
                isEmpty.value = true;
            }
            isLoading.value = false;
        }

        const fetchPolls = async () => {
            const response = await api.getPolls();

            if (response.ok) {
                polls.value = response.data.results;
            } else {
                alert(response.error);
            }
        };


        const fetchSurveys = async () => {
            const response = await api.getSurveys();

            if (response.ok) {
                surveys.value = response.data;
            } else {
                alert(response.error);
            }
        };

        onMounted(() => {
            fetch();
        });

        return {
            polls,
            surveys,
            isLoading,
            isEmpty
        }
    }
}

</script>